'use strict';

import {
  SubscriptionCoupons,
  SubscriptionPlans,
  SubscriptionPlanPrices,
} from '../../model/domain/subscription';
import { ContractPlans } from '../../model/domain/contract';

export default class PaymentSuccessController {
  /**
   * @ngInject
   */
  constructor(
    $log,
    $q,
    $stateParams,
    BreadcrumbService,
    CacheService,
    StaticContentService,
  ) {
    this.$log = $log;
    this.$stateParams = $stateParams;
    this.$q = $q;

    /** @type {BreadcrumbService} */
    this._breadcrumbService = BreadcrumbService;
    /** @type {CacheService} */
    this._cacheService = CacheService;
    /** @type {StaticContentService} */
    this._staticContentService = StaticContentService;

    this._loading = true;
    this._nextCharge = undefined;

    this.init();
  }

  init() {
    this._cacheService
      .getSubscriptions(true)
      .then((subscriptions) => {
        this._subscription = subscriptions.find(
          (subscription) => subscription.id === this.subscriptionId,
        );
        this._nextCharge = this.subscription.nextCharge;
        this._loading = false;
      })
      .catch((error) => {
        this._error = error;
        this.$log.error(error.message);
      });
  }

  /**
   * @returns {string}
   */
  get subscriptionId() {
    return this.$stateParams.subscriptionId;
  }

  /**
   * @returns {Subscription}
   */
  get subscription() {
    return this._subscription;
  }

  get subscriptionPlan() {
    return this.subscription && this.subscription.subscriptionPlan;
  }

  goBack() {
    this._breadcrumbService.goBack('root.account.home');
  }

  goHome() {
    this._breadcrumbService.go('root.account.home', {}, true);
  }

  goToGettingStartedWithPro() {
    this._staticContentService.goToGettingStartedTutorialVideo();
  }

  goToWatchTutorialVideo() {
    this._staticContentService.goToPortfolioStudentTutorialVideo();
  }

  get loading() {
    return this._loading;
  }

  get error() {
    return this._error;
  }

  get planPrice() {
    return '$9.99';
  }

  get annualOrMonthly() {
    return this.subscriptionPlan === SubscriptionPlans.NiagaraMonthlyV8
      ? 'Monthly'
      : 'Annual';
  }

  get nextCharge() {
    return this._nextCharge;
  }

  get planDiscount() {
    if (
      this.coupon &&
      this.coupon.toLowerCase() ===
        SubscriptionCoupons.getCoupon(this.coupon)?.code
    ) {
      return `${SubscriptionCoupons.getCoupon(this.coupon)?.discountPercentage} off (-$${SubscriptionCoupons.getCoupon(this.coupon)?.discountAmount})`;
    } else {
      return '--';
    }
  }

  get coupon() {
    return this.subscription && this.subscription.coupon;
  }

  get planPriceDiscount() {
    const basePrice = SubscriptionPlanPrices.NiagaraMonthlyV8;

    if (!this.coupon) {
      return `$${basePrice}`;
    }

    const couponData = SubscriptionCoupons.getCoupon(this.coupon);
    const isValidCoupon =
      couponData && this.coupon.toLowerCase() === couponData.code;

    if (isValidCoupon) {
      const discountedPrice = basePrice - couponData.discountAmount;
      return `$${discountedPrice}`;
    }

    return `$${basePrice}`;
  }

  get totalPrice() {
    if (this.coupon) {
      return this.planPriceDiscount;
    } else {
      return this.planPrice;
    }
  }
}
